import { render, staticRenderFns } from "./FormWizardSlider.vue?vue&type=template&id=2b6eb8de&"
import script from "./FormWizardSlider.vue?vue&type=script&lang=js&"
export * from "./FormWizardSlider.vue?vue&type=script&lang=js&"
import style0 from "./FormWizardSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports